export const ACADEMIC_PROBATION_ADVISING_LINK = 'https://calendly.com/academic-advising-5/academic-probation-advising';
